import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { Url } from '@wix/da-url';
import { Trans, useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import Hidden from './Icons/Hidden';
import Button from '../../Button';
const NsfgBlockedOverlay = (props)=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        title: t('deviationview.blocked.nsfg.anon'),
        text: props.compact ? null : /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: "deviationview.blocked.nsfg.anon.text"
        }, "This filter hides content that may be", ' ', /*#__PURE__*/ React.createElement("a", {
            className: "text-link-level-2-primary",
            href: t('deviationview.blocked.nsfg.anon.text.url')
        }, "inappropriate for some viewers")),
        button: /*#__PURE__*/ React.createElement(Button, {
            view: "b14",
            height: props.compact ? 'small' : 'medium',
            // Keeping joinpoint=mature since it was specifically requested in the ticket
            href: Url.joinLink('mature'),
            biData: {
                evid: BiEventType.REDIRECT_TO_LOGIN,
                referral_info: ReferralType.NSFG
            }
        }, t('deviationview.blocked.nsfg.anon.signIn'))
    }, props));
};
NsfgBlockedOverlay.displayName = 'NsfgBlockedOverlay';
export default NsfgBlockedOverlay;
